var React = require('react');

function IcoPerson (props) {
    return React.createElement("svg",props,React.createElement("image",{"width":"15","height":"32","xlinkHref":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAgCAQAAABnJeoiAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhBAwNLCc6eTZpAAABTUlEQVQoz53RMUvDQBjG8cdYoVqtTgURpIPi4AdwcRBche4i4uDkIrg5Sb+CCK4Kgh/ARRycbBUEtaCTCBULtaJCU6vVlv4dLk2vTXDwbsjz3o/3ktwJWXOANAXKHDFtVmzsYYvWyJEwPMsOSwgxzC3tkTJcBGAeMciVxQuG7wHI0IvY8DHLiOE1b2ERIdbJcMMe461PGyIHwDVJ4vQxxgT9xIgh1IO0rH1JUl5VOWqoqYgicrWtAyGiXBA2HkiYP07RCOEqM60DOQ7tTzmSJJRWQ8GRdLxwrsMQnnT8uKtKkNsX4pANvDvf7m7qLNA96ljFXYBP7fue69j4khXiNk918CZC9uYVla3qXVIH11S0qtdu/rT4O8g1lfzs6q2bpWc/lf/mjzB+sbp/glxS3U8K46qXnv7FX14qhHHdHKWkR+9J51zFxeWEqKl/AewFb88JwM8+AAAAAElFTkSuQmCC"}));
}

IcoPerson.defaultProps = {"width":"15","height":"32","viewBox":"0 0 15 32"};

module.exports = IcoPerson;

IcoPerson.default = IcoPerson;
